/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { riskItemEntrySchema } from './riskItemEntrySchema';

export const paginatedResultRiskItemEntrySchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(riskItemEntrySchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
  totalCount: z.int().nullish(),
});
